// FE-SCRM-055 — REST client for the Tag library endpoints.

import { api } from "@/api/client";

import type { TagInventoryResponse } from "./types";


export function fetchTagInventory(
  opts?: { signal?: AbortSignal },
): Promise<TagInventoryResponse> {
  return api.get<TagInventoryResponse>(
    "/api/v1/sales/tags/inventory", opts,
  );
}


export function renameTag(input: {
  from_tag: string;
  to_tag: string;
}): Promise<{ tag: string; slug: string }> {
  return api.post<{ tag: string; slug: string }>(
    "/api/v1/sales/tags/rename", input,
  );
}


export function mergeTag(input: {
  from_tag: string;
  into_tag: string;
}): Promise<{ tag: string; slug: string }> {
  return api.post<{ tag: string; slug: string }>(
    "/api/v1/sales/tags/merge", input,
  );
}


export function deleteTag(input: {
  tag: string;
}): Promise<{ tag: string; slug: string }> {
  return api.post<{ tag: string; slug: string }>(
    "/api/v1/sales/tags/delete", input,
  );
}
